module.exports = __webpack_public_path__ + "static/img/banner.3ac67fb3.png";